module.exports = __webpack_public_path__ + "red-location.png";